import { ref } from 'vue';

const props = ref({
  passwordForgotForm: {
    email: '',
    turnstileToken: null,
  },
  passwordResetForm: {
    password: '',
    confirmPassword: '',
    key: '',
    token: '',
  },
});

export { props };
